import UserLogin from "../components/UserLogIn/UserLogIn";
import { Header } from "../components/Header/Header";
export function LoginPage () {
    return (
        <>
            <Header />
            <UserLogin />
        </>
    )
}